var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "timedout-layout" } }, [
    _c("div", { staticClass: "container" }, [
      _c("p", { staticClass: "headline-large gray" }, [
        _vm._v(_vm._s(_vm.$t("timedoutView.title"))),
      ]),
      _c("div", { staticClass: "container-img" }, [
        _c("img", {
          attrs: { src: require("@/assets/images/self-care/timedout.png") },
        }),
        _c("p", { staticClass: "text-medium gray mg mg--t-5" }, [
          _vm._v(_vm._s(_vm.$t("timedoutView.text.upper"))),
        ]),
        _c("p", { staticClass: "text-medium gray mg mg--t-5" }, [
          _vm._v(_vm._s(_vm.$t("timedoutView.text.lower"))),
        ]),
        _c("p", { staticClass: "text-medium gray mg mg--t-5" }, [
          _vm._v(_vm._s(_vm.$t("timedoutView.text.lower2"))),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }